import './App.css';
import { useSelector } from "react-redux";
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Body from './components/Body';

const App = () => {
  const status = useSelector((state) => state.sidebar.status)
  const marginLeft = status ? '250px' : '0px';
  return (
    <div>
        <Sidebar />
        <div id = "main" style = {{marginLeft: marginLeft}}>
            <Header />
            <Body />
        </div>
    </div>
  );
}

export default App;
